module.exports = __webpack_public_path__ + "static/media/dizzy.b32f083c.svg";